module.exports = __webpack_public_path__ + "static/img/4-msg.0ff8f4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/4-msg.png
// module id = yu3z
// module chunks = 1